import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export async function openExternal(url: string) {
  const isNative = Capacitor.isNativePlatform();
  try {
    if (isNative) {
      await Browser.open({ url, presentationStyle: 'popover' });
    } else {
      window.location.assign(url);
    }
  } catch {
    window.location.assign(url);
  }
}
